module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-e54998a8fe454b8c43707f1970a63918.png";